module.exports = __webpack_public_path__ + "img/2-3.92b856d8.png";